export const importFromCsv = {
  title: '洗濯機部品のCSVインポート',
  importSuccessfully: '洗濯機の部品のインポートに成功しました！',
  importFailed: '洗濯機の部品のインポートに失敗しました！',
}
